import { Iterable, IPlace } from "types";

/*
    Function need to fix multiple countries places collecting problem
    (when we can select places only from one country, becaus in this country 
        all places has bigger rating than in other countries)

    1. Pass places only sorted by rating;
    2. Pass countries iso2 codes;

    Return:
    Each country code select one plase with highest rating from this country;

    Example:
    places: [
        {rating: 4.9, rating: 'SK'},
        {rating: 4.8, code: 'SK'}, 
        {rating: 4.7, code: 'SK'}, 
        {rating: 4.5, code: 'UA'},  
        {rating: 4.2, code: 'UA'},
    ]
    countryCodes: ['UA', 'SK];

    Return: [
        {rating: 4.5, code: 'UA'},  
        {rating: 4.9, rating: 'SK'},
        {rating: 4.2, code: 'UA'},
        {rating: 4.8, code: 'SK'},
        {rating: 4.7, code: 'SK'},
    ]
*/

export const sortByCountries = (
  places: Iterable<IPlace>[],
  countryCodes: string[]
) => {
  const sortedPlaces: typeof places = [];
  const usedIndexes: number[] = [];

  if (places.length === 0 || countryCodes.length === 0) {
    return places;
  }

  let previusCodeIndex = 0;

  while (sortedPlaces.length < places.length) {
    if (sortedPlaces.length === 0) {
      for (const [codeIndex, countryCode] of countryCodes.entries()) {
        const placeIndex = places.findIndex(
          (item) => item.address_info.country_code === countryCode
        );

        if (placeIndex > -1) {
          sortedPlaces.push(places[placeIndex]);
          usedIndexes.push(placeIndex);
          previusCodeIndex = codeIndex;
          break;
        }
      }

      continue;
    }

    const nextCountryCodeIndex = countryCodes.at(previusCodeIndex + 1)
      ? previusCodeIndex + 1
      : 0;
    const nextCountryCode = countryCodes[nextCountryCodeIndex];

    const nextPlaceIndex = places.findIndex(
      (item, placeIndex) =>
        item.address_info.country_code === nextCountryCode &&
        !usedIndexes.includes(placeIndex)
    );

    if (nextPlaceIndex > -1) {
      sortedPlaces.push(places[nextPlaceIndex]);
      usedIndexes.push(nextPlaceIndex);
    }

    previusCodeIndex = nextCountryCodeIndex;
  }

  return sortedPlaces;
};
